import { createRoute, retainSearchParams } from '@tanstack/react-router';
import { z } from 'zod';
import { ProtectedLayout } from '../components/protected-layout.tsx';
import { Route as root } from './root.tsx';
export const Route = createRoute({
  getParentRoute: () => root,
  id: '_signedIn',
  validateSearch: z.object({ chatId: z.string().optional(), siteId: z.string().optional() }).parse,
  search: { middlewares: [retainSearchParams(['chatId', 'siteId'])] },
  component: ProtectedLayout,
});
